module.exports = __webpack_public_path__ + "img/threeday1-3.d5a1fe88.jpg";